import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Button, ButtonProps } from "@/components/ui";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
import { formatToHumanReadable } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { SelfScheduleStep, isSelfScheduleComplete } from "@/stores/self-schedule-store";
type BackButtonProps = Omit<ButtonProps, "children">;
export const BackButton = t0 => {
  const $ = _c(19);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    currentStep,
    previousStep,
    determinePreviousStep,
    firstStep,
    shouldExposeLocationTypeChoice,
    shouldShowLocationBeforeService
  } = useSelfScheduleContext();
  let t1;
  if ($[3] !== previousStep) {
    t1 = () => {
      previousStep();
    };
    $[3] = previousStep;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleBack = t1;
  let t2;
  bb0: {
    if (!firstStep || currentStep === null || isSelfScheduleComplete(currentStep)) {
      t2 = false;
      break bb0;
    }
    if (currentStep === SelfScheduleStep.SERVICE) {
      if (shouldShowLocationBeforeService) {
        t2 = true;
        break bb0;
      }
      t2 = currentStep !== firstStep && !(firstStep === SelfScheduleStep.PATIENT_TYPE && !shouldExposeLocationTypeChoice);
      break bb0;
    }
    const hideOn = new Set([SelfScheduleStep.SECURE_APPOINTMENT, SelfScheduleStep.CHECKOUT]);
    if (hideOn.has(currentStep)) {
      t2 = false;
      break bb0;
    }
    t2 = currentStep !== firstStep;
  }
  const showBackButton = t2;
  if (!firstStep || currentStep === null) {
    return null;
  }
  const t3 = !showBackButton ? "pointer-events-none !h-0 border-none p-0 text-transparent" : "motion-preset-slide-down";
  let t4;
  if ($[5] !== className || $[6] !== t3) {
    t4 = cx("px-0", t3, className);
    $[5] = className;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FaArrowLeft className="text-xxs" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== determinePreviousStep) {
    t6 = formatToHumanReadable(determinePreviousStep());
    $[9] = determinePreviousStep;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <span>Back to {t6}</span>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== currentStep || $[14] !== handleBack || $[15] !== props || $[16] !== t4 || $[17] !== t7) {
    t8 = <Button data-testid="back-button" variant="ghost" size="sm" onClick={handleBack} key={currentStep} className={t4} {...props} icon={t5}>{t7}</Button>;
    $[13] = currentStep;
    $[14] = handleBack;
    $[15] = props;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};